angular.module('tf.directives')

.directive("bypassConfirm",['$window',function($window){
        return {
            restrict: "A",
            link: function(scope, element){
                element.bind('click', function(){
                    $window.onbeforeunload = null;
                });
            }
        };

    }]);
